export default __webpack_public_path__ + "static/media/chakraUI.b3bf302a.svg";